import type { ReactNode } from 'react'
import { Page } from '@dhl/page'
import { Language } from '@dhl/i18n'

type Props = {
  languages: string[]
  children?: ReactNode
  isLoading: boolean
  testId?: string
}

export const BasePage = ({ languages, ...props }: Props) => (
  <Page {...props} isReloadable={false} headerContent={<Language locales={languages} />} />
)
